export default __webpack_public_path__ + "static/media/pass.763bc1c6.gif";